/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Toast_Generate_ErrorInputs */

const en_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate questions`)
};

const de_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen konnten nicht generiert werden`)
};

const fr_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de générer les questions`)
};

const es_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron generar las preguntas`)
};

const it_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione delle domande non riuscita`)
};

const nl_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragen genereren mislukt`)
};

const pl_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wygenerować pytań`)
};

const fi_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kysymysten luominen epäonnistui`)
};

const da_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke generere spørgsmål`)
};

const sv_interview_prepare_toast_generate_error = /** @type {(inputs: Interview_Prepare_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte generera frågor`)
};

/**
* | output |
* | --- |
* | "Failed to generate questions" |
*
* @param {Interview_Prepare_Toast_Generate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_toast_generate_error = /** @type {((inputs?: Interview_Prepare_Toast_Generate_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Toast_Generate_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_toast_generate_error(inputs)
	if (locale === "fr") return fr_interview_prepare_toast_generate_error(inputs)
	if (locale === "es") return es_interview_prepare_toast_generate_error(inputs)
	if (locale === "it") return it_interview_prepare_toast_generate_error(inputs)
	if (locale === "nl") return nl_interview_prepare_toast_generate_error(inputs)
	if (locale === "pl") return pl_interview_prepare_toast_generate_error(inputs)
	if (locale === "fi") return fi_interview_prepare_toast_generate_error(inputs)
	if (locale === "da") return da_interview_prepare_toast_generate_error(inputs)
	if (locale === "sv") return sv_interview_prepare_toast_generate_error(inputs)
	return en_interview_prepare_toast_generate_error(inputs)
});